
import React from "react";

import CleanUpLogs from "../component/CleanUpLogs";

const CleanUpLogsContainer = ({ pageId }) => (<CleanUpLogs pageId={ pageId } />)

export default CleanUpLogsContainer; 